import classNames from 'classnames'
import React, { ReactNode } from 'react'

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode
}

export const LayoutMain = ({ title, children, className, ...props }: Props) => {
  return (
    <main className={classNames(className, 'p-8 pt-6 grid grid-rows-[auto_1fr] gap-6 w-full h-full')} {...props}>
      {title}
      <div className="flex flex-col min-h-0">{children}</div>
    </main>
  )
}
